/**
 * 返回顶部
 */

require('./gotop.css');

var gotop = {
	init: function (){
		//<a href="http://acttg.eastmoney.com/pub/wap_act_16cgds_hdrk_01_01_03_0"><span class="sai"></span></a><br />
		var html = $('<div id="go_top"><span class="topimg"></span></div>');
		$('body').append(html);

		$('.topimg', html).on('click', function (){
			window.scrollTo(0, 0);
		});

		$(window).scroll(function () {
            if ($(window).scrollTop() > $(window).height()) {
                html.fadeIn();
            } else {
                html.fadeOut();
            }
        });
	}
}

module.exports = gotop;


//////////////////
// WEBPACK FOOTER
// ./dev/modules/gotop/gotop.js
// module id = 10
// module chunks = 11